import { render } from "./VendorForm.vue?vue&type=template&id=42e9e26c&scoped=true"
import script from "./VendorForm.vue?vue&type=script&lang=js"
export * from "./VendorForm.vue?vue&type=script&lang=js"

import "./VendorForm.vue?vue&type=style&index=0&id=42e9e26c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42e9e26c"]])

export default __exports__